<script setup lang="ts">
import Dialog from "primevue/dialog";

withDefaults(
  defineProps<{
    title: string;
    eyebrow?: string;
    busy?: boolean;
    wide?: boolean;
  }>(),
  { busy: false, wide: false }
);
const visible = defineModel<boolean>({ required: true });
defineEmits<{ close: [] }>();
</script>

<template>
  <Dialog
    v-model:visible="visible"
    modal
    :header="title"
    :closable="!busy"
    :closeOnEscape="!busy"
    :draggable="false"
    :pt="{
      root: {
        class: [
          'cnmc-dialog d-flex flex-column border',
          { 'cnmc-dialog--wide': wide },
        ],
      },
      mask: { class: 'cnmc-dialog-mask' },
      header: {
        class:
          'd-flex align-items-center justify-content-between border-bottom px-3 px-md-4 py-3 flex-shrink-0',
      },
      content: { class: 'overflow-auto p-0' },
      footer: { class: 'p-0 flex-shrink-0' },
      pcCloseButton: {
        root: { class: 'btn btn-link text-body-secondary p-2 ms-auto' },
      },
    }"
    @hide="$emit('close')"
  >
    <template #header>
      <div>
        <div v-if="eyebrow" class="eyebrow-label eyebrow-label--sm mb-1">
          {{ eyebrow }}
        </div>
        <h4 class="font-serif mb-0">{{ title }}</h4>
      </div>
    </template>
    <slot />
    <template #footer><slot name="footer" /></template>
  </Dialog>
</template>

<style scoped lang="scss">
:global(.cnmc-dialog) {
  background: var(--phoenix-emphasis-bg);
  color: var(--phoenix-body-color);
  width: min(860px, calc(100vw - 2rem));
  max-height: calc(100dvh - 2rem);
  border-radius: 12px;
  overflow: hidden;
}
:global(.cnmc-dialog--wide) {
  width: min(1140px, calc(100vw - 2rem));
}
:global(.cnmc-dialog-mask) {
  background: rgba(34, 40, 52, 0.45);
}
</style>
